<div class="container mt-8">
  <div class="grid grid-cols-1">
    <!--<div class="relative overflow-hidden lg:px-8 px-6 py-10 rounded-xl shadow-lg dark:shadow-gray-700">-->
      <h3 class="mb-6 md:text-[26px] text-2xl md:leading-normal leading-normal font-semibold">Disciplines</h3>
      In dit overzicht tonen we de disciplines waarvoor we ondersteuning aanbieden. Klik op de items om een woordje uitleg te vinden over die discipline en een opsomming te zien van de specialisaties binnen elk domein.
    <!--</div>-->
  </div>
</div>

<div class="container">
  <div class="grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-[30px] mt-12 mb-32">

    <app-discipline-card *ngFor="let disc of disciplines" [disc]="disc"></app-discipline-card>

  </div>
</div>
